import { useSuspenseQuery } from '@tanstack/react-query';
import { userQueries } from '@/features/auth/queries';

export function useCurrentUser() {
  return useSuspenseQuery(userQueries.getCurrentUser()).data;
}
